import { Body, colors, Spacer, TooltipIcon } from '@spritz-finance/ui'
import styled from 'styled-components'
import usdcLogo from '../../../../../assets/img/usdc.svg'
import { Column } from '../../../../../components/Layout/Column'
import { Row } from '../../../../../components/Layout/Row'
import { useScreenSize } from '../../../../../context/useScreenSize'
import { cssVar } from '../../../../../theme/utils'
import { useCreateSubscription } from './create/CreateSubscriptionProvider'

const Container = styled.div`
    border: 1px solid var(--text-secondary, ${colors.medGrey});
    padding: 9px 16px;
    border-radius: 6px;
`

const Logo = styled.img`
    width: 32px;
`

export const USDCBalance = () => {
    const { container } = useCreateSubscription()
    const { isMobile } = useScreenSize()

    return (
        <>
            <Row>
                <Spacer width={16} />
                <Body.Med size={12} secondary>
                    Pay with
                </Body.Med>
                <TooltipIcon
                    size={24}
                    side="top"
                    boundary={container}
                    controlled={isMobile}
                    text="SMARTPay subscriptions are currently only available using USDC on the Polygon network."
                />
            </Row>
            <Spacer height={8} />
            <Container>
                <Row>
                    <Logo src={usdcLogo} />
                    <Spacer width={4} />
                    <Column>
                        <Body.Bold color={cssVar('--text-tertiery', colors.medGrey)} size={16}>
                            USDC
                        </Body.Bold>
                    </Column>
                </Row>
            </Container>
        </>
    )
}
